export default __webpack_public_path__ + "static/Refinery-25Medium-b8d3505f468f7e2889ff2b69c745b206.woff2";